/* eslint-disable*/
import React from "react";
import SystemMaintenanceMasterManagement_CureCleanScheduleSetup from "./CureCleanScheduleSetup";
import { screen, cleanup } from "@testing-library/react";
import "regenerator-runtime/runtime";
import userEvent from "@testing-library/user-event";
import { act } from "react-dom/test-utils";
import axios from "axios";
import renderTestScreen from "../../../../common/renderTestScreen";
import { t } from "../../../../__mocks__/react-i18next";

describe("CureCleanScheduleSetup Test Cases", () => {
  beforeEach(async () => {
    act(() => {
      renderTestScreen(
        <SystemMaintenanceMasterManagement_CureCleanScheduleSetup />
      );
    });
  });
  afterEach(cleanup);
  test("is CureCleanScheduleSetup Loads Successfully", () => {
    expect(screen.getByText("CureCleanScheduleSetup")).toBeInTheDocument;
  });
  test("Custom Test Cases for CureCleanScheduleSetup", () => {
    // START_USER_CODE-USER_CureCleanScheduleSetup_Custom_Test_Case
    // END_USER_CODE-USER_CureCleanScheduleSetup_Custom_Test_Case
  });
});
describe("Widget Test Cases", () => {
  beforeEach(async () => {
    act(() => {
      renderTestScreen(
        <SystemMaintenanceMasterManagement_CureCleanScheduleSetup />
      );
    });
  });
  afterEach(cleanup);
  test("btnAdd(Button Widget) Test Cases", async () => {
    const btnAdd = screen.getByTestId("btnAdd");
    expect(btnAdd).toBeInTheDocument;
    expect(btnAdd.textContent).toEqual(
      t("SystemMaintenanceMasterManagement:CureCleanScheduleSetup_btnAdd")
    );
  });
  test("Custom Test Cases for btnAdd", () => {
    // START_USER_CODE-USER_btnAdd_TEST
    // END_USER_CODE-USER_btnAdd_TEST
  });
  test("btnClose(Button Widget) Test Cases", async () => {
    const btnClose = screen.getByTestId("btnClose");
    expect(btnClose).toBeInTheDocument;
    expect(btnClose.textContent).toEqual(
      t("SystemMaintenanceMasterManagement:CureCleanScheduleSetup_btnClose")
    );
  });
  test("Custom Test Cases for btnClose", () => {
    // START_USER_CODE-USER_btnClose_TEST
    // END_USER_CODE-USER_btnClose_TEST
  });
  test("btncmdEnableDisableControls(Button Widget) Test Cases", async () => {
    const btncmdEnableDisableControls = screen.getByTestId(
      "btncmdEnableDisableControls"
    );
    expect(btncmdEnableDisableControls).toBeInTheDocument;
    expect(btncmdEnableDisableControls.textContent).toEqual(
      t(
        "SystemMaintenanceMasterManagement:CureCleanScheduleSetup_btncmdEnableDisableControls"
      )
    );
  });
  test("Custom Test Cases for btncmdEnableDisableControls", () => {
    // START_USER_CODE-USER_btncmdEnableDisableControls_TEST
    // END_USER_CODE-USER_btncmdEnableDisableControls_TEST
  });
  test("btnDelete(Button Widget) Test Cases", async () => {
    const btnDelete = screen.getByTestId("btnDelete");
    expect(btnDelete).toBeInTheDocument;
    expect(btnDelete.textContent).toEqual(
      t("SystemMaintenanceMasterManagement:CureCleanScheduleSetup_btnDelete")
    );
  });
  test("Custom Test Cases for btnDelete", () => {
    // START_USER_CODE-USER_btnDelete_TEST
    // END_USER_CODE-USER_btnDelete_TEST
  });
  test("btnEdit(Button Widget) Test Cases", async () => {
    const btnEdit = screen.getByTestId("btnEdit");
    expect(btnEdit).toBeInTheDocument;
    expect(btnEdit.textContent).toEqual(
      t("SystemMaintenanceMasterManagement:CureCleanScheduleSetup_btnEdit")
    );
  });
  test("Custom Test Cases for btnEdit", () => {
    // START_USER_CODE-USER_btnEdit_TEST
    // END_USER_CODE-USER_btnEdit_TEST
  });
  test("grpbxCureCleanSchedule(GroupBox Widget) Test Cases", async () => {
    const grpbxCureCleanSchedule = screen.getByTestId("grpbxCureCleanSchedule");
    expect(grpbxCureCleanSchedule.tagName).toBe("BUTTON");
    expect(grpbxCureCleanSchedule.type).toBe("button");
    expect(grpbxCureCleanSchedule.classList).toContain("btn");
  });
  test("Custom Test Cases for grpbxCureCleanSchedule", () => {
    // START_USER_CODE-USER_grpbxCureCleanSchedule_TEST
    // END_USER_CODE-USER_grpbxCureCleanSchedule_TEST
  });
  test("lblCureCleanSchedule(Label Widget) Test Cases", async () => {
    const lblCureCleanSchedule = screen.getByTestId("lblCureCleanSchedule");
    expect(lblCureCleanSchedule.tagName).toBe("LABEL");
    expect(lblCureCleanSchedule.classList).toContain("form-label");
    expect(lblCureCleanSchedule.textContent).toEqual(
      t(
        "SystemMaintenanceMasterManagement:CureCleanScheduleSetup_lblCureCleanSchedule"
      )
    );
  });
  test("Custom Test Cases for lblCureCleanSchedule", () => {
    // START_USER_CODE-USER_lblCureCleanSchedule_TEST
    // END_USER_CODE-USER_lblCureCleanSchedule_TEST
  });
});
